import { PromoWithTotalDiscount } from 'anchor-shared/lib/model/entity/discount';
import { Charter } from 'anchor-shared/lib/model/entity/charter';

export function getPromoAmountFromCharter(charter: Charter): number {
  if (
    charter.pricingMetaData &&
    charter.pricingMetaData.promoCode &&
    charter.pricingMetaData.promoCode.promoDiscountAmount
  ) {
    return charter.pricingMetaData.promoCode.promoDiscountAmount;
  } else {
    return 0;
  }
}
